(() => {
  console.log("GLOBAL VEHICLE FILTER");
  function applyFilter(preferredFilter = null) {
    const wrapper = document.querySelector(".section-vehicle-filter--wrapper");
    const loadingIcon = document.querySelector(
      ".section-vehicle-filter--wrapper .loading-icon",
    );
    if (!wrapper) return;
    const showLoadingIcon = () => {
      if (loadingIcon) loadingIcon.classList.add("visible");
    };

    const hideLoadingIcon = () => {
      if (loadingIcon) loadingIcon.classList.remove("visible");
    };

    const updateVehicleTitles = (vehicleName) => {
      if (!vehicleName) return;
      document.querySelectorAll("[data-global-vehicle-title]").forEach((el) => {
        el.textContent = vehicleName;
      });
    };

    const applyVehicleFilter = (filter) => {
      wrapper.classList.remove("empty-filter");
      wrapper.classList.add("closed");
      if (document.querySelector('variant-selects[data-tire-picker]')) {
        const url = new URL(window.location.href);
        url.searchParams.set('filter.p.m.organizer.car_models', filter.vehicleName);
        history.replaceState(history.state, '', url);
        hideLoadingIcon();
        return;
      }
      const suspension = document.querySelector('njt-suspension');
      if (suspension) {
        if (typeof suspension.setVehicle === 'function') suspension.setVehicle(filter.vehicleName);
        else customElements.whenDefined('njt-suspension').then(() => {
          if (suspension.isConnected) suspension.setVehicle(filter.vehicleName);
        });
        hideLoadingIcon();
        return;
      }
      const searchParams = new URLSearchParams(window.location.search);

      if (
        filter.vehicleCollectionHandle != "" &&
        window.location.pathname.includes(filter.vehicleCollectionHandle)
      ) {
        hideLoadingIcon();
        return;
      }

      if (searchParams.has("filter.p.m.organizer.car_models")) {
        const param = searchParams.get("filter.p.m.organizer.car_models");
        if (param === filter.vehicleName) {
          hideLoadingIcon();
          return;
        }
      }
      const shouldForce =
        document
          .querySelector("#global-vehicle-filter")
          ?.dataset.productType?.includes("wheels") ||
        window.location.pathname.includes("products") ||
        false;
      if (window.location.pathname.includes("collections") || shouldForce) {
        searchParams.set("filter.p.m.organizer.car_models", filter.vehicleName);
        window.location.search = searchParams.toString();
      }
    };
    let filter = null;
    try { filter = JSON.parse(localStorage.getItem('gta-global-vehicle-filter') || 'null'); } catch (_) {}
    const requestedVehicle = new URLSearchParams(window.location.search).get('filter.p.m.organizer.car_models');
    if (preferredFilter) filter = preferredFilter;
    if (requestedVehicle && !preferredFilter) {
      const option = [...document.querySelectorAll('#vehicle-identifiers option')].find(option => option.value === requestedVehicle);
      filter = {vehicleName: requestedVehicle, vehicleCollectionHandle: option?.dataset.vehicleCollectionHandle || '', vehicleTitleOverwrite: option?.dataset.vehicleTitleOverwrite || requestedVehicle};
    }
    const historyReturn = window.performance?.getEntriesByType?.('navigation')[0]?.type === 'back_forward';
    if (historyReturn && window.location.pathname.includes('/collections/') && !requestedVehicle && !preferredFilter) filter = null;
    const hasFilter = Boolean(filter?.vehicleName && filter.vehicleName !== 'VEHICLE');
    try {
      showLoadingIcon();
      if (hasFilter) {
        if (window.Shopify?.globalVehicleFilter?.vehicle_page) {
          hideLoadingIcon();
          return;
        }
        applyVehicleFilter(filter);
      } else {
        wrapper.classList.add('empty-filter');
        wrapper.classList.toggle("closed",Boolean(document.querySelector("njt-vehicle-strip")));
      }
      hideLoadingIcon();
    } catch (e) {
      console.error(e);
    } finally {
      hideLoadingIcon();
      const confirm = wrapper.querySelector('.confirm-button');
      confirm?.classList.remove('loading');
      if (document.querySelector('#vehicle-identifiers')?.value !== 'VEHICLE') confirm?.removeAttribute('disabled');
      updateVehicleTitles(filter?.vehicleTitleOverwrite || filter?.vehicleName);
    }
  }

  async function updateCartAttribute(value, callback) {
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 5000);
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { "Vehicle Filter": value } }),
        signal: controller.signal,
        keepalive: true,
      });
      if (!response.ok) throw new Error('Vehicle cart update failed');
    } catch (e) {
      console.error("Failed to update cart attribute", e);
    } finally {
      window.clearTimeout(timer);
      callback();
    }
  }

  function setFilter(vehicle, autoApply = true) {
    if (!vehicle?.vehicleName || vehicle.vehicleName === 'VEHICLE') return Promise.resolve();
    try { localStorage.setItem("gta-global-vehicle-filter", JSON.stringify(vehicle)); } catch (e) { console.error(e); }
    const syncing = updateCartAttribute(vehicle.vehicleTitleOverwrite || vehicle.vehicleName, () => {});
    if (autoApply) applyFilter(vehicle);
    return syncing;
  }

  function filterWheelVariants(marker, storedFilter) {
    const model = window.NJTWheelModel;
    if (!model) return;
    const params = new URLSearchParams(window.location.search);
    let savedVehicle = '';
    try { savedVehicle = JSON.parse(storedFilter || 'null')?.vehicleName || ''; } catch (_) {}
    const vehicle = model.normalize(params.get('filter.p.m.organizer.car_models') || savedVehicle);
    const selected = Object.fromEntries(['size', 'width', 'offset'].map(field => [field, params.getAll('njt_' + field)]));
    if (!vehicle && !Object.values(selected).some(values => values.length)) return;
    const section = marker.parentElement.querySelector('[id^="MainProduct-"]');
    if (!section) return;
    const requestedId = params.get('variant');
    section.querySelectorAll('variant-selects select').forEach(select => {
      if (!select.querySelector('[data-variant-filter-vehicles]')) return;
      select.classList.add('njt-wheel-selected-size');
      const picker = select.closest('variant-selects');
      const variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
      const allOptions = select.njtWheelOptions || [...select.options];
      select.njtWheelOptions = allOptions;
      const vehicleOptions = allOptions.filter(option => {
        const vehicles = (option.dataset.variantFilterVehicles || '').split('/#/').map(model.normalize);
        return !vehicle || vehicles.includes(vehicle);
      });
      const eligible = vehicleOptions.filter(option => {
        const spec = model.parseSpec(option.value);
        return Object.entries(selected).every(([field, values]) => !values.length || (spec && values.includes(spec[field])));
      });
      const requested = variants.find(variant => String(variant.id) === requestedId);
      const preferred = eligible.find(option => requested && option.value === requested.option1)
        || eligible.find(option => option.value === select.value) || eligible[0];
      if (preferred && !select.njtWheelOriginalValue) select.njtWheelOriginalValue = preferred.value;
      const oldValue = select.value;
      select.replaceChildren(...eligible);
      if (preferred) select.value = preferred.value;
      select.disabled = !preferred;
      const parent = select.closest('.product-form__input');
      parent.classList.add('njt-wheel-size-input');
      const mainLabel = parent.querySelector('label');
      if (mainLabel) mainLabel.textContent = marker.dataset.selectedSize || mainLabel.textContent;
      let note = parent.querySelector('.njt-wheel-variant-note');
      if (!note) {
        note = document.createElement('small');
        note.className = 'njt-wheel-variant-note';
        note.setAttribute('role', 'status');
        note.style.display = 'block';
        note.style.marginTop = '5px';
        parent.append(note);
      }
      note.textContent = preferred ? marker.dataset.filteredMessage : marker.dataset.emptyMessage;
      // Keep the broader size selector outside variant-selects: the theme reads
      // every select inside that component as a separate product option.
      let alternatives = section.querySelector('.njt-wheel-alternatives');
      const boltPatterns = value => model.normalize(String(value).split('|')[2]).replace(/\s/g, '').split('OR');
      const currentPatterns = preferred ? boltPatterns(preferred.value) : [];
      const otherOptions = vehicleOptions.filter(option => boltPatterns(option.value).some(pattern => currentPatterns.includes(pattern)));
      if (!alternatives && preferred && otherOptions.some(option => !eligible.includes(option))) {
        alternatives = document.createElement('details');
        alternatives.className = 'njt-wheel-alternatives';
        const summary = document.createElement('summary');
        summary.textContent = marker.dataset.otherSizes;
        const help = document.createElement('p');
        help.textContent = vehicle ? marker.dataset.otherSizesVehicle : marker.dataset.otherSizesPattern;
        const groups = document.createElement('div');
        groups.className = 'njt-wheel-size-groups';
        alternatives.append(summary, help, groups);
        picker.after(alternatives);
        groups.addEventListener('click', event => {
          const button = event.target.closest('button[data-wheel-option]');
          if (!button) return;
          const variant = variants.find(variant => variant.option1 === button.dataset.wheelOption);
          const spec = model.parseSpec(button.dataset.wheelOption);
          if (!variant || !spec) return;
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          for (const field of ['size', 'width', 'offset']) url.searchParams.set('njt_' + field, spec[field]);
          window.history.replaceState({}, '', url);
          filterWheelVariants(marker, storedFilter);
          if (select.value === select.njtWheelOriginalValue) {
            alternatives.open = false;
            select.focus({preventScroll: true});
          } else {
            const chosen = [...groups.querySelectorAll('button')].find(button => button.dataset.wheelOption === select.value);
            chosen?.focus({preventScroll: true});
          }
        });
        select.addEventListener('change', () => {
          alternatives.querySelectorAll('button[data-wheel-option]').forEach(button => {
            button.setAttribute('aria-pressed', String(button.dataset.wheelOption === select.value));
          });
          if (select.value === select.njtWheelOriginalValue) alternatives.open = false;
        });
      }
      if (alternatives) {
        const groups = alternatives.querySelector('.njt-wheel-size-groups');
        const expanded = new Set([...groups.querySelectorAll('details[open]')].map(group => group.dataset.size));
        const grouped = new Map();
        for (const option of otherOptions) {
          const spec = model.parseSpec(option.value);
          if (!spec) continue;
          if (!grouped.has(spec.size)) grouped.set(spec.size, []);
          grouped.get(spec.size).push(option);
        }
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style: 'currency', currency: marker.dataset.currency || 'CAD'});
        const fragment = document.createDocumentFragment();
        for (const [size, options] of [...grouped].sort((a, b) => Number(a[0]) - Number(b[0]))) {
          const group = document.createElement('details');
          group.className = 'njt-wheel-size-group';
          group.dataset.size = size;
          group.open = expanded.has(size) || model.parseSpec(select.value)?.size === size;
          const heading = document.createElement('summary');
          heading.textContent = (marker.dataset.sizeOptions || '__SIZE__ inch · __COUNT__ options').replace('__SIZE__', size).replace('__COUNT__', options.length);
          group.append(heading);
          for (const option of options) {
            const variant = variants.find(variant => variant.option1 === option.value);
            const spec = model.parseSpec(option.value);
            const button = document.createElement('button');
            button.type = 'button';
            button.dataset.wheelOption = option.value;
            button.className = 'njt-wheel-size-choice';
            button.setAttribute('aria-pressed', String(option.value === select.value));
            const title = document.createElement('span');
            title.textContent = spec.size + ' × ' + spec.width + ' · ' + (Number(spec.offset) > 0 ? '+' : '') + spec.offset + ' mm';
            const fitment = document.createElement('small');
            fitment.textContent = option.value.split('|').slice(2).map(value => value.trim()).join(' · ');
            const price = document.createElement('span');
            price.className = 'njt-wheel-size-choice__price';
            price.textContent = variant ? money.format(variant.price / 100) : '';
            const selectedMark = document.createElement('span');
            selectedMark.className = 'njt-wheel-size-choice__selected';
            selectedMark.textContent = marker.dataset.selected || 'Selected';
            button.append(title, price, fitment, selectedMark);
            group.append(button);
          }
          fragment.append(group);
        }
        groups.replaceChildren(fragment);
        alternatives.hidden = !preferred || !otherOptions.some(option => !eligible.includes(option));
      }
      if (preferred && oldValue !== preferred.value) select.dispatchEvent(new Event('change', {bubbles: true}));
      if (!preferred) section.querySelectorAll('button[name="add"]').forEach(button => { button.disabled = true; });
    });
  }

  function variantHandler() {
    const selectedVehicle=new URL(location.href).searchParams.get("filter.p.m.organizer.car_models");
    const filter=selectedVehicle?JSON.stringify({vehicleName:selectedVehicle}):location.pathname.includes("/collections/")?null:localStorage.getItem("gta-global-vehicle-filter");
    const isWheelProduct = document.querySelector("#is-wheel-product");
    if (isWheelProduct) filterWheelVariants(isWheelProduct, filter);
    const allProductCompatibilityElement = document.querySelectorAll(
      "[data-product-compatibility]",
    );
    if (!filter && !isWheelProduct) {
  allProductCompatibilityElement.forEach((component) => {
    const tagElement = component.querySelector(".product-compatible-tag");

    if (tagElement) {
      if(component.closest("#product-grid, .njs-grid, .njt-wheels__grid")){tagElement.style.display="none";return;}
      tagElement.style.display = "flex";
      tagElement.innerHTML = `
        <span style="color:#f4b400; font-size:18px;">⚠</span>
        <span style="color:#d65a00; font-weight:800;">
          Select Your Vehicle to Verify Fitment
        </span>
      `;
      tagElement.style.gap = "6px";
      tagElement.style.alignItems = "center";
      tagElement.style.backgroundColor = "transparent";
      tagElement.style.border = "none";
      tagElement.style.padding = "0";
    }
  });
}
    if (filter) {

      const vehicle = JSON.parse(filter).vehicleName;
      if (allProductCompatibilityElement.length > 0) {
        allProductCompatibilityElement.forEach((component) => {
          try {
            const scriptTag = component.querySelector("script");
            const productCompatibility = JSON.parse(scriptTag?.textContent);
            if (!productCompatibility || !Array.isArray(productCompatibility)) {
              console.warn(
                "Invalid or missing product compatibility data",
                component,
              );
              return;
            }
            const isCompatible = productCompatibility.some((item) => {
              return (
                item.toLowerCase() == vehicle.toLowerCase() ||
                item.toLowerCase() == "all vehicles"
              );
            });
            const tagElement = component.querySelector(
              ".product-compatible-tag",
            );
            if (tagElement && isCompatible) {
              tagElement.style.display = "flex";
            } else if (tagElement) {
              if (
                window.location.pathname.includes("products") &&
                component.closest(".product__info-container") &&
                !isWheelProduct
              ) {
                tagElement.style.display = "flex";
                const alertIcon = document.createElement("span");
                alertIcon.textContent = "⚠️ ";
                tagElement.innerHTML = ""; // Clear previous content
                tagElement.appendChild(alertIcon);
                tagElement.appendChild(
                  document.createTextNode(
                    "This product is not compatible with your vehicle",
                  ),
                );
                tagElement.style.color = "#ff0018";
                tagElement.style.fontWeight = "bold";
                tagElement.style.padding = "8px";
                tagElement.style.border = "1px solid #f8d7da";
                tagElement.style.backgroundColor = "#ffff";
              } else {
                tagElement.style.display = "none";
              }
            }
          } catch (e) {
            console.error(component, e);
          }
        });
  
}

    }
  }

  function appendFilterToInternalLinks() {
    const allLinks = document.querySelectorAll(
      "a[href*='/collections/'], a[href*='/products/']",
    );
    const filter = localStorage.getItem("gta-global-vehicle-filter");
    if (!filter) return;
    const jsonFilter = JSON.parse(filter);
    const vehicle = jsonFilter.vehicleName;
    allLinks.forEach((link) => {
      const url = new URL(link.href);
      if (
        url.pathname.includes("filter.p.m.organizer.car_models") ||
        (jsonFilter.vehicleCollectionHandle && url.pathname.includes(jsonFilter.vehicleCollectionHandle))
      ) {
        return; // Skip links that already have the filter applied
      }
      if (
        url.pathname.includes("/collections/") ||
        url.pathname.includes("/products/")
      ) {
        const searchParams = new URLSearchParams(url.search);
        searchParams.set("filter.p.m.organizer.car_models", vehicle);
        url.search = searchParams.toString();
        link.href = url.toString();
      }
    });
  }

  window.globalVehicleFilter = {
    setFilter,
    applyFilter,
    variantHandler,
    clearFilter: () => {
      localStorage.removeItem("gta-global-vehicle-filter");
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete("filter.p.m.organizer.car_models");
      const doReload = () => {
        const suspension = document.querySelector('njt-suspension');
        if (typeof suspension?.setVehicle === 'function') {
          suspension.setVehicle('');
          const picker = document.querySelector('.section-vehicle-filter--wrapper');
          picker?.classList.add('empty-filter', 'closed');
          return;
        }
        window.location.search = urlParams.toString();
      };
      updateCartAttribute("", doReload);
    },
  };
  document.addEventListener('njt:vehicle-state', () => {
    appendFilterToInternalLinks();
    variantHandler();
  });
  applyFilter();
  window.addEventListener("DOMContentLoaded", variantHandler);
  document.addEventListener("njt:grid-appended",variantHandler);
  document.addEventListener("njt:grid-updated",variantHandler);
  window.addEventListener("DOMContentLoaded", appendFilterToInternalLinks);
})();

